import PropTypes from "prop-types";
import React from "react";
import { NavLoader } from "ui/loader";

class AppNav extends React.Component {
  static get propTypes() {
    return {
      className: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      className: "",
    };
  }

  render() {
    const { className } = this.props;

    return (
      <div className={`app-nav ${className}`} role="navigation">
        <NavLoader />
      </div>
    );
  }
}

export { AppNav };
